export const types = {
  SET_COOKIES: "SET_COOKIES",
  SET_PANEL: "SET_PANEL",
};

export const actions = {
  setCookies: (cookies) => ({ type: types.SET_COOKIES, cookies }),
  setPanel: (isOpen) => ({ type: types.SET_PANEL, isOpen }),
};
